import { Button } from 'react-bootstrap';

const ProfileMobileSectionActions = ({ isEditing, onEdit, onCancel, onSave, show = true }) => {
    if (!show) return null;

    return (
        <div className={`profile-mobile-section-actions d-lg-none${isEditing ? '' : ' profile-mobile-section-actions--single'}`}>
            {isEditing ? (
                <>
                    <Button variant="outline-secondary" className="profile-mobile-action-button" onClick={onCancel}>Cancel</Button>
                    <Button variant="primary" className="profile-mobile-action-button" onClick={onSave}>Save</Button>
                </>
            ) : (
                <Button variant="outline-secondary" className="profile-mobile-action-button" onClick={onEdit}>Edit</Button>
            )}
        </div>
    );
};

export default ProfileMobileSectionActions;
